import { Search } from "lucide-react";
import { FiltersBar, FilterConfig } from "../FiltersBar";

export const SupplierFilter = () => {
  const filters: FilterConfig[] = [
    {
      type: "select",
      placeholder: "Product Category",
      options: [
        { value: "automotive", label: "Automotive Parts" },
        { value: "electronics", label: "Electronics" },
        { value: "machinery", label: "Machinery" },
        { value: "textiles", label: "Textiles" },
        { value: "chemicals", label: "Chemicals" },
      ],
    },
    {
      type: "select",
      placeholder: "Country/Region",
      options: [
        { value: "cn", label: "🇨🇳 China" },
        { value: "in", label: "🇮🇳 India" },
        { value: "us", label: "🇺🇸 United States" },
        { value: "de", label: "🇩🇪 Germany" },
        { value: "tr", label: "🇹🇷 Turkey" },
      ],
    },
    {
      type: "switch",
      label: "Verified Suppliers Only",
    },
    {
      type: "select",
      placeholder: "Sort By",
      options: [
        { value: "relevance", label: "Relevance" },
        { value: "rating", label: "Rating" },
        { value: "latest", label: "Latest" },
        { value: "experience", label: "Experience" },
      ],
    },
    {
      type: "button",
      label: "Search",
      icon: Search,
      variant: "primary",
    },
  ];

  return (
    <div className="bg-white border-b border-border sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4">
        <FiltersBar filters={filters} showSearch={true} card={false} />
      </div>
    </div>
  );
};

export default SupplierFilter;
